<template>
  <div class="stock-document-line-totals">
    <div class="stock-document-line-totals__item">
      <div class="stock-document-line-totals__label">
        {{ $t("STOCK.COMMON.TOTAL_AMOUNT_KG") }}
      </div>
      <div class="stock-document-line-totals__value">{{ formattedQuantity }}</div>
    </div>
    <div v-if="showPrice" class="stock-document-line-totals__item">
      <div class="stock-document-line-totals__label">
        {{ $t("STOCK.COMMON.TOTAL_PRICE") }}
      </div>
      <div class="stock-document-line-totals__value">{{ formattedPrice }}</div>
    </div>
  </div>
</template>

<script>
import { formatQty } from "@/common/stock/productPackagingConversion";

export default {
  name: "StockDocumentLineTotals",
  props: {
    lines: {
      type: Array,
      default: () => [],
    },
    showPrice: {
      type: Boolean,
      default: true,
    },
    currencyCode: {
      type: String,
      default: "",
    },
  },
  computed: {
    productLines() {
      return (this.lines || []).filter((line) => line.stock_product_id);
    },
    totalQuantityKg() {
      return this.productLines.reduce((sum, line) => sum + Number(line.quantity || 0), 0);
    },
    totalPrice() {
      return this.productLines.reduce((sum, line) => {
        const value =
          line.line_total_net != null && line.line_total_net !== ""
            ? Number(line.line_total_net)
            : 0;
        return sum + (Number.isFinite(value) ? value : 0);
      }, 0);
    },
    formattedQuantity() {
      return formatQty(this.totalQuantityKg);
    },
    formattedPrice() {
      const amount = Number(this.totalPrice || 0).toFixed(2);
      return this.currencyCode ? `${amount} ${this.currencyCode}` : amount;
    },
  },
};
</script>

<style scoped>
.stock-document-line-totals {
  display: flex;
  flex-wrap: wrap;
  gap: 24px 40px;
  margin-top: 12px;
  padding: 10px 12px;
  background: #f5f5f5;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
}

.stock-document-line-totals__label {
  font-size: 11px;
  letter-spacing: 0.02em;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 2px;
}

.stock-document-line-totals__value {
  font-size: 16px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  line-height: 1.3;
}
</style>
